import { render, staticRenderFns } from "./LibSearchFormHost.vue?vue&type=template&id=22435672&scoped=true&"
import script from "./LibSearchFormHost.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LibSearchFormHost.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LibSearchFormHost.vue?vue&type=style&index=0&id=22435672&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22435672",
  null
  
)

export default component.exports